// external imports
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormGroup, Input } from 'reactstrap';
import { createSiteComment } from 'actions';
import CreatableSelect from 'react-select/creatable';
import config from 'config';
import { API } from 'aws-amplify';

// internal imports
import {
	fetchSiteComments,
	fetchCommentStatuses,
	fetchCommentCategories
} from 'actions';
import { getAuthenticatedUserAttributes } from 'actions';
import { CommentRow } from './CommentRow';

export const CommentsTable = ({ updateSite }) => {
	const dispatch = useDispatch();
	const initialFormValues = {
		category_id: null,
		labels: null,
		content: {
			text: null,
			attachment: {
				title: null,
				s3uri: null,
				mimetype: null
			}
		}
	};

	const [replyingToId, setReplyingToId] = useState(null);
	const [replyText, setReplyText] = useState('');
	const [labels, setLabels] = useState('');
	const [userHandle, setUserHandle] = useState(null);
	const [showDeletedComments, setShowDeletedComments] = useState(false);
	const [formValues, setFormValues] = useState(initialFormValues);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [uploadError, setUploadError] = useState(null);
	const [editingComment, setEditingComment] = useState(null);
	const [repliesExpanded, setRepliesExpanded] = useState(false);

	const siteComments = useSelector((state) => state.siteComments);
	const commentStatuses = useSelector((state) => state.commentStatuses);
	const commentCategories = useSelector((state) => state.commentCategories);
	const filteredComments = !showDeletedComments
		? siteComments?.filter((comm) => comm.content.text !== '[deleted]')
		: siteComments;

	useEffect(() => {
		if (!updateSite?.id) return;

		getUser();
		dispatch(
			fetchSiteComments({
				subject_id: updateSite.id
			})
		);
		dispatch(fetchCommentStatuses());
		dispatch(fetchCommentCategories());
	}, [updateSite?.id]);

	const getUser = async () => {
		const { familyName, givenName } = await getAuthenticatedUserAttributes();
		setUserHandle(`${givenName.toLowerCase()}.${familyName.toLowerCase()}`);
	};

	// const getSiteInfo = async (id) => {
	// 	return API.get(
	// 		config.gainsApi.NAME,
	// 		replacer(config.gainsApiEndpoints.siteInfo, { id }),
	// 		{
	// 			headers: {}
	// 		}
	// 	);
	// };

	const getPresignedUrl = async (file) => {
		console.log('file', file);

		return API.post(config.qcApi.NAME, config.qcApiEndpoints.getPresignedUrl, {
			headers: {
				'Content-Type': 'application/json'
			},
			body: {
				file_name: file.name,
				mime_type: file.type
			}
		});
	};

	const uploadAttachmentToBucket = async (file) => {
		console.log('file', file);

		try {
			const response = await getPresignedUrl(file);

			console.log('response', response);

			if (!response?.upload_url || !response?.s3uri) {
				setUploadError(`Failed to get presigned URL`);
				setUploadedFile(null);
			}

			const uploadResponse = await fetch(response?.upload_url, {
				method: 'PUT',
				headers: {
					'Content-Type': file.type
				},
				body: file
			});

			console.log('uploadResponse', uploadResponse);

			return {
				s3uri: response?.s3uri,
				title: file.name,
				mimetype: file.type
			};
		} catch (error) {
			setUploadError('Attachment upload failed');
			setUploadedFile(null);
			return;
		}
	};

	console.log('uploadedFile', uploadedFile);

	const handleSubmitComment = async (e, rowId) => {
		e.preventDefault();
		if (!updateSite.id) return;

		let attachment = null;
		if (uploadedFile) {
			attachment = await uploadAttachmentToBucket(uploadedFile);
			console.log('attachment', attachment);

			if (!attachment) {
				console.error('Attachment upload failed');
				setUploadError('Attachment upload failed');
			}
		}

		let content = {
			text: formValues.content.text,
			attachment: attachment
		};

		let payload = {
			subject_id: updateSite.id,
			user_id: userHandle,
			content: content,
			status_id: 1,
			category_id: formValues?.category_id,
			labels: labels
		};

		console.log('payload', payload);

		dispatch(createSiteComment(payload));
		setLabels('');
		setFormValues(initialFormValues);
	};

	const handleUserUploadsAttachment = async (e) => {
		const file = e.target.files?.[0];
		if (!file) return;

		const attachment = {
			title: file.name,
			mimetype: file.type
		};

		setUploadedFile(file);
		setFormValues((prev) => ({
			...prev,
			content: {
				...prev.content,
				attachment: attachment
			}
		}));
	};

	const handleDowndloadUploadedFile = async (attachment) => {
		console.log('attachment', attachment);
		try {
			const response = await fetch(attachment.url);
			console.log(response);

			if (!response.ok) {
				console.error('Failed to download attachment');
			}

			const blob = await response.blob();
			const url = window.URL.createObjectURL(blob);

			const link = document.createElement('a');
			link.href = url;
			link.download = attachment.title;

			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Error downloading attachment:', error);
		}
	};

	const isFormValid = () => {
		let formValid = true;

		if (!formValues.content.text) {
			formValid = false;
		}

		return formValid;
	};

	const formatDate = (date) => {
		return `${date.slice(8, 10)}-${date.slice(5, 7)}-${date.slice(2, 4)}`;
	};

	const renderCategoryDropdown = (
		disabled,
		row,
		thisFormValues,
		setThisFormValues
	) => {
		return (
			<FormGroup>
				<Input
					name="category"
					type="select"
					disabled={disabled || editingComment}
					value={thisFormValues?.category_id ?? null}
					onChange={(e) => {
						const value = Number(e.target.value);

						setThisFormValues((prev) => ({
							...prev,
							category_id: value
						}));
					}}
				>
					<option value="" disabled>
						Choose a category
					</option>

					{commentCategories?.map((opt) => (
						<option value={opt.id} key={opt.id}>
							{opt.name}
						</option>
					))}
				</Input>
			</FormGroup>
		);
	};

	const renderUploadFileBtn = () => {
		console.log(editingComment);
		if (!uploadedFile) {
			return (
				<>
					<input
						type="file"
						id="comment-file-upload"
						onChange={handleUserUploadsAttachment}
						name="fileUploadComment"
						style={{ display: 'none' }}
						disabled={!!editingComment}
					/>

					<label
						htmlFor={editingComment ? undefined : 'comment-file-upload'}
						className={`btn btn-sm my-0 py-0 iconHover ${
							editingComment ? 'disabled' : ''
						}`}
						id="comment-upload-attachment-button"
						title="Upload an attachment to support this comment"
					>
						<i className="fa-solid fa-file-arrow-up my-0 py-0 iconHover" />
					</label>
				</>
			);
		} else {
			return (
				<>
					<button
						type="button"
						title={`Delete uploaded file "${uploadedFile?.title}"`}
						onClick={() => setUploadedFile(null)}
						htmlFor="comment-file-upload"
						className="btn btn-sm my-0 py-0 iconHover"
						id="comment-upload-attachment-button"
						disabled={!!editingComment}
					>
						<i className="fa-solid fa-file-circle-xmark iconHover"></i>
					</button>
				</>
			);
		}
	};

	const renderNewCommentForm = () => {
		return (
			<tr>
				<td>
					<input
						className="form-control"
						type="text"
						value={formValues?.content?.text ?? ''}
						onChange={(e) => {
							const value = e.target.value;

							setFormValues((prev) => ({
								...prev,
								content: {
									...prev?.content,
									text: value
								}
							}));
						}}
						disabled={editingComment}
						placeholder="Add a new comment..."
					/>
				</td>

				<td>
					{renderCategoryDropdown(false, null, formValues, setFormValues)}
				</td>

				<td>
					{formatDate(
						new Date().toISOString().replace('T', ' ').replace('Z', '')
					)}
				</td>

				<td>{userHandle}</td>

				<td>open</td>
				<td
					title={
						'Type a new label and press Enter on your keyboard to save it as an option.'
					}
				>
					<CreatableSelect
						isMulti
						isClearable
						options={labels.split(',').map((l) => {
							return { label: l, value: l };
						})}
						value={
							labels
								? labels.split(',').map((label) => ({
										label: label.trim(),
										value: label.trim()
									}))
								: []
						}
						onChange={(selected) => {
							const labels =
								selected?.map((item) => item.value).join(', ') || '';
							setLabels(labels);
						}}
						placeholder="Add labels..."
						isDisabled={!!editingComment}
					/>
				</td>
				<td>
					{renderUploadFileBtn()}

					<button
						type="button"
						className="btn btn-info btn-sm mx-2"
						title="Add comment"
						disabled={!isFormValid() || editingComment}
						onClick={(e) => handleSubmitComment(e)}
					>
						Add
					</button>
				</td>
			</tr>
		);
	};

	return (
		<div className="p-3">
			<div className="form-check ms-3 mt-1">
				<input
					id="show-deleted-comments-checkbox"
					type="checkbox"
					checked={showDeletedComments}
					onChange={() => setShowDeletedComments((prev) => !prev)}
					className="form-check-input"
				/>

				<label
					htmlFor="show-deleted-comments-checkbox"
					className="form-check-label"
				>
					Show deleted comments
				</label>
			</div>

			<table className="table table-sm table-borderless CommentsTable">
				<thead>
					<tr>
						<th>Comment</th>
						<th>Category</th>
						<th>Created</th>
						<th>Created by</th>
						<th>Status</th>
						<th>Labels</th>
						<th>Actions</th>
					</tr>
				</thead>

				<tbody>
					{filteredComments?.map((row) => (
						<CommentRow
							key={row.id}
							row={row}
							replyText={replyText}
							setReplyText={setReplyText}
							setReplyingToId={setReplyingToId}
							replyingToId={replyingToId}
							//handleSubmitComment={handleSubmitComment}
							formatDate={formatDate}
							renderCategoryDropdown={renderCategoryDropdown}
							commentStatuses={commentStatuses}
							userHandle={userHandle}
							uploadedFile={uploadedFile}
							setUploadedFile={setUploadedFile}
							handleUserUploadsAttachment={handleUserUploadsAttachment}
							updateSite={updateSite}
							editingComment={editingComment}
							setEditingComment={setEditingComment}
							repliesExpanded={repliesExpanded}
							setRepliesExpanded={setRepliesExpanded}
							uploadAttachmentToBucket={uploadAttachmentToBucket}
							handleDowndloadUploadedFile={handleDowndloadUploadedFile}
						/>
					))}

					{renderNewCommentForm()}
				</tbody>
			</table>
		</div>
	);
};
